import React from "react";
import { Link } from "react-router-dom";

const Icon = ({ d, d2 }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d={d} />
    {d2 && <path d={d2} />}
  </svg>
);

const WHY_ITEMS = [
  {
    iconD: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
    title: "Research-Led Engineering",
    desc: "Ongoing investments in solutions for upgradation and research. Cutting-edge solutions with significant market potential, built on proprietary SOA frameworks and modern architectures.",
  },
  {
    iconD: "M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z",
    title: "Proven Execution Capabilities",
    desc: "A strong technology focus with effective and efficient delivery mechanisms. Process-driven with ISO 9001 quality systems across every engagement — from System Architecture Design to onsite implementation and training.",
  },
  {
    iconD: "M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
    title: "Global Enterprise Delivery",
    desc: "Clients in over 70 countries across North America, Europe, Middle East, APAC and Africa since 1992. Modular and configurable solutions customized for industry verticals — deployed and client-accepted.",
  },
  {
    iconD: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
    title: "Long-Term Technology Partnership",
    desc: "We don't hand over and walk away. Applications designed around solutions that provide additional value, backed by a unique value proposition built on 30+ years of experience and enterprise software delivery expertise.",
  },
  {
    iconD: "M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z",
    title: "Enterprise Data Exchange & Integration",
    desc: "Seamless integration among cloud and on-premise applications via DXchange — our API Management platform. Used across Insurance, Banking, Travel, Healthcare and Legal for enterprise data exchange and Marketing Automation workflows.",
  },
  {
    iconD: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z",
    title: "Enterprise AI Enablement on Existing Systems",
    desc: "Big data and analytics, data integration, ETL, machine learning and AI enablement — layered onto existing enterprise systems at your pace. Business Rules Engine (BRMS) and Content Management Systems that make AI actionable.",
  },
  {
    iconD: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
    title: "Quality Systems (ISO 9001:2015)",
    desc: "Quality focus across all delivery mechanisms. A large pool of experienced resources with proven offshore and international delivery capability. Centralized Reservation Systems and booking management built to enterprise-grade quality standards.",
  },
  {
    iconD: "M13 10V3L4 14h7v7l9-11h-7z",
    title: "Proprietary Platforms & Accelerators",
    desc: "DXchange API Management, BizRuleEngine (BRMS), CMS, Umrah Booking Solution, Travel ERP and more — off-the-shelf products that cut delivery time and reduce risk on enterprise software projects.",
  },
];

const NewWhyUs = () => (
  <section className="why-v2" aria-labelledby="why-heading" id="why-avani-cimcon">
    <div className="container">
      <div className="row mb-5">
        <div className="col-lg-8">
          <p className="section-eyebrow" style={{ textAlign: "left", color: "#f37417" }}>Why Avani Cimcon</p>
          <h2 id="why-heading" style={{ fontSize: "clamp(1.5rem,3vw,2.1rem)", fontWeight: 800, color: "#fff", marginBottom: "16px" }}>
            30 years of enterprise software delivery. Now AI-first.
          </h2>
          <p style={{ fontSize: "15px", color: "rgba(255,255,255,.65)", lineHeight: 1.7, margin: 0, maxWidth: "620px" }}>
            <Link to="/about" style={{ color: "rgba(255,255,255,.85)", fontWeight: 600, textDecoration: "underline" }}>Avani Cimcon Technologies</Link> provides
            state-of-the-art technology solutions and services to organizations across Travel,
            Insurance, Financial Services, Healthcare, Legal, Transportation and more —
            leveraging 30+ years of domain expertise in Enterprise Data Exchange, Marketing
            Automation, Content Management, Business Rules Engine, Booking Engines and
            Central Reservation Systems.
          </p>
        </div>
      </div>

      <div className="row">
        {WHY_ITEMS.map(({ iconD, title, desc }) => (
          <div key={title} className="col-lg-3 col-md-6 mb-4">
            <div className="why-v2-card">
              <div className="why-v2-card-icon-wrap" aria-hidden="true">
                <Icon d={iconD} />
              </div>
              <h3>{title}</h3>
              <p>{desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 d-flex flex-wrap" style={{ gap: "12px" }}>
        <Link to="/advantage" className="hero-v2-btn-primary">
          ACT Advantage
        </Link>
        <Link to="/expertise-experience" className="hero-v2-btn-outline">
          Expertise &amp; Experience
        </Link>
        <Link to="/services/legacy-modernization" className="hero-v2-btn-outline">
          Modernization Framework
        </Link>
        <Link to="/value-proposition" className="hero-v2-btn-outline">
          Value Proposition
        </Link>
      </div>
    </div>
  </section>
);

export default NewWhyUs;
